import { Dispatch, SetStateAction } from "react";
import { Typography, IconButton, Grid2 } from "@mui/material";
import { Close } from "@mui/icons-material";

type Props = {
  title: string;
  setInventory: Dispatch<SetStateAction<string | undefined>>;
  onClose: () => void;
};

export const DialogContentHeader = ({ title, setInventory, onClose }: Props) => {
  return (
    <Grid2 container>
      <Grid2 size={"grow"} />
      <Grid2 size={{ xs: 9 }} sx={{ marginBottom: "10px" }}>
        <Typography align={"center"} lineHeight={2.5}>
          {title}
        </Typography>
      </Grid2>
      <Grid2 size={"grow"} sx={{ textAlign: "right" }}>
        <IconButton
          sx={{ float: "right" }}
          data-testid="btn-group-close"
          onClick={() => {
            setInventory(undefined);
            onClose();
          }}
          size="large"
        >
          <Close />
        </IconButton>
      </Grid2>
    </Grid2>
  );
};
